import { CheckmarkVerifiedIcon } from '@change/ds-icons';

import { Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { useProfileCardRedesign } from '../../hooks/useProfileCardRedesign';

export function NameAndTitle() {
	const {
		data: { displayName, title, districtStateText, verified },
	} = useProfileCardRedesign();

	return (
		<div className="flex flex-col items-center text-content-primary lg:items-start" data-qa="dm-header">
			<Text as="p" variant="body" size="large" className="hidden text-content-secondary lg:block">
				<Translate value="corgi.decision_maker_profile.profile_section.label" />
			</Text>
			<div className="my-2 flex items-start">
				<Text as="h1" variant="heading" className="my-0 mb-2 text-4xl xl:text-5xl" data-qa="dm-name">
					{displayName}
				</Text>
				{verified && (
					<CheckmarkVerifiedIcon size="small" data-testid="verified-badge" className="text-icon-accent-primary ml-2" />
				)}
			</div>
			<Text as="p" variant="body" className="text-center lg:text-left" data-qa="dm-title">
				{title}
			</Text>
			{districtStateText && (
				<Text as="p" data-testid="dm-profile-location" variant="body">
					{districtStateText}
				</Text>
			)}
		</div>
	);
}
